<script>
/**
 * Concept Quicktable
 *
 * @Version 1.0
 * @Author Daniel Lepe
 */
import { captions, buildAPIFromTipo } from "./archetype.js";

import QuickCardFooter from "@/views/elements/quick-card-footer.vue";
import axios from "axios";
import automodal from "./automodal.vue";
import UsuarioModal from "../../Usuarios/assets/usuarioModal.vue";
import loncheraPenalizacion from "../elements/lonchera-penalizacion.vue";

let name = "presenciasQuickTable",
	newButtonLabel = "Nueva",
	emptyHeader = "Datos no encontrados",
	emptyLead = "Módulo vacío",
	reloadData = "Intenta recargando esta página",
	tryAgainLater = "",
	header = null,
	footer = null;

export default {
	name,

	components: {
		automodal,
		QuickCardFooter,
		UsuarioModal,
		loncheraPenalizacion
	},

	props: {
		tipo: {
			type: String,
			required: false,
		},
		cedesId: {
			type: [String, Number],
		},
		gruposId: {
			type: [String, Number],
		},
		header: {
			type: String,
			default: () => {
				return header;
			},
		},
		perPage: {
			type: Number,
			default: 10,
		},
		footer: {
			type: String,
			default: () => {
				return footer;
			},
		},
		captions: {
			type: [Array, Object],
			default: () => captions,
		},
	},

	computed: {
		sourceURI() {
			let init =
				buildAPIFromTipo(this.tipo, this.cedesId, this.gruposId) +
				"/" +
				this.perPage +
				"/" +
				this.currentPage;
			if (!!this.term) {
				init += "/" + this.term;
			} else if (!this.term || this.term == "s") {
				init += "/@";
			}
			return init;
		},
	},

	data: () => {
		return {
			name,
			newButtonLabel,
			emptyHeader,
			emptyLead,
			tryAgainLater,
			reloadData,
			currentPage: 1,
			items: [],
			itemsCount: 0,
			term: null,
			isLoading: false,
		};
	},

	methods: {
		async refreshFromStart() {
			this.currentPage = 1;
			this.refresh();
		},
		async refresh() {
			this.isLoading = true;
			await this.loadUp();
			this.isLoading = false;
		},
		async loadUp() {
			try {
				let response = await axios.get(this.sourceURI);
				this.items = response.data.rows;
				this.itemsCount = response.data.count;
				this.loading = false;
			} catch (error) {
				console.error(error);
			}
		},
	},

	watch: {
		currentPage(a, b) {
			this.refresh();
		},
		$route() {
			this.loadUp();
		},
	},

	mounted() {
		this.refresh();
	},
};
</script>

<template>
	<div :id="name">

		<lonchera-penalizacion ref="loncheraPenalizacion" @refresh="refresh"/>

		<b-card no-body>

			<!-- TABLE CONTENT -->
			<b-table v-if="items.length && !isLoading" class="animated fadeIn" responsive :items="items" :fields="captions">

				<template #cell(monedero)="data">
					<strong class="adeudo" v-if="data.value < 0">{{ data.value | currency }}</strong>
					<strong v-else>{{ data.value | currency }}</strong>
				</template>

				<template #cell(usuarioImagen)="data">
					<img-portal :src="data.value" v-if="items.length && !isLoading" allow-zoom />
				</template>

				<template #cell(_)="data">
					<b-button-group size="sm">
						<usuario-modal btnClass="btn btn-secondary" @refresh="refresh"
							:concept-id="data.item.usuario_id_pk">
							<i class="fa fa-user"></i>
						</usuario-modal>
						<automodal :concept-id="data.item.id" @refresh="refresh" :tipoDefault="tipo">
							Editar
						</automodal>
						<b-button variant="danger" v-if="($route.meta && $route.meta.tipo == 'alumno')" @click="$refs.loncheraPenalizacion.penalize(data.item.id)">
							<i class="icon icon-easylunch-sadbox confy-icon" key="icon-easylunch-sadbox"></i>
						</b-button>
					</b-button-group>
				</template>
			</b-table>

			<!-- LOADING SPINNER -->
			<div v-if="isLoading">
				<div class="text-center p-5">
					<b-spinner variant="primary" />
				</div>
			</div>

			<!-- EMPTY JUMBOTRON -->
			<div v-else-if="!items.length" class="pt-4 pl-4 pr-4 pb-0">
				<b-jumbotron :header="emptyHeader" :lead="emptyLead">
					<p>{{ tryAgainLater }}</p>
					<b-button variant="primary" @click="refresh()">
						{{ reloadData }}
					</b-button>
				</b-jumbotron>
			</div>

			<!-- HEADER -->
			<template v-slot:header>
				<b-row align-h="between">
					<b-col md="auto" v-if="!!header">
						<h6 class="mt-2 mb-2">{{ header }}</h6>
					</b-col>

					<b-col>
						<b-input-group>
							<b-form-input v-model="term" @keyup.enter="refreshFromStart()" placeholder="Buscador..." />
							<b-input-group-append>
								<b-button v-if="!!term" variant="secondary" @click="
									term = '';
								refreshFromStart();
								"><i class="fa fa-times"></i></b-button>
								<b-button variant="secondary" @click="refreshFromStart()" :disabled="!term"><i
										class="fa fa-search"></i></b-button>
							</b-input-group-append>
						</b-input-group>
					</b-col>

					<!-- <b-col md="auto" class="align-right">
						<automodal @refresh="refresh" :tipoDefault="tipo">
							Nuevo
						</automodal>
					</b-col> -->
				</b-row>
			</template>

			<!-- FOOTER -->
			<template v-slot:footer v-if="!isLoading && items.length">
				<quick-card-footer v-model="currentPage" :items-count="itemsCount" :per-page="perPage"
					:items-fetched="items.length" @refresh="refresh" />
			</template>

		</b-card>
	</div>
</template>

<style lang="less">
#presenciasQuickTable {
	.adeudo {
		color: var(--danger);
	}

	.personalize-btn {
		.btn {
			display: inline;
			text-align: inherit;
			border: none;
			padding: 0;
			line-height: inherit;
			border-radius: inherit;
		}
	}
}
</style>